import { DataSource } from '@csnext/cs-data';

export class LayerSource extends DataSource {


}
